<template>
  <div class="select-chevron" :class="classObj"></div>
</template>

<script>
export default {
  props: {
    opened: Boolean,
    invalid: Boolean
  },
  computed: {
    classObj() {
      return {
        "is-opened": this.opened,
        "is-invalid": this.invalid
      };
    }
  }
};
</script>

<style lang="scss">
.select-chevron {
  transition: 0.4s;

  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 7px solid colors(palette-1);

  &.is-opened {
    transform: rotateX(180deg);
    border-top: 7px solid colors(palette-3);
  }

  &.is-invalid {
    border-top-color: colors(warning);
  }
}
</style>
